// `__ONIRI_API_URL__` is injected at build time by esbuild `define` (see
// esbuild.config.mjs). Override per ambiente:
//   ONIRI_API_URL=<url> npm run build:prod
// In dev / unit tests il valore default è lo staging URL.

const FALLBACK_BASE_URL = 'https://oniri-viewer-api-staging.mirko-vescio.workers.dev';

export function getApiBaseUrl(): string {
  const injected = (globalThis as { __ONIRI_API_URL__?: string }).__ONIRI_API_URL__;
  if (typeof injected === 'string' && injected.length > 0) {
    return injected;
  }
  return FALLBACK_BASE_URL;
}
